// extracted by mini-css-extract-plugin
export default {"logo":"AppHeader_logo__1kOOE","logoLogin":"AppHeader_logoLogin__z69UO"};